import { render, staticRenderFns } from "./TileDataOMNeighborhoods.vue?vue&type=template&id=6d87158b&"
import script from "./TileDataOMNeighborhoods.vue?vue&type=script&lang=js&"
export * from "./TileDataOMNeighborhoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports